<script setup lang="ts">
import { onMounted, reactive, watch } from "vue"
import Status from './StatusComponenet.vue'


definePage({
  meta: {
      action: 'manage',
      subject: 'TCA',
  },
})

interface Props {
  isShow: boolean[],
  applicationNumber: string,
  status: string,
  issueDate: string,
  documentNumber: string,
  // 傳入userNo
  userInfo: string,
  statusComponent: string,
}
interface Emit {
  (e: 'update:isDialogVisible', value: boolean): void
  (e: 'update:permissionName', value: string): void
}

const props = withDefaults(defineProps<Props>(), {
  isShow: () => [true, true, true, true, true, true],
  applicationNumber: '',
  status: '',
  issueDate: '',
  documentNumber: '',
  userInfo: '',
  statusComponent: "",
})

const emit = defineEmits<Emit>()
const compId = ref('nstc')
const userData = useStorage<any>('userData', {}).value
const user = reactive<any>({})
const displayStatus = computed(() => props.applicationNumber ? props.status : '');

const statusColors = computed(() => {
  if (props.statusComponent === 'ExpenseReimbursement') {
    return {
      isRed: ['Rejected', 'Revoke', 'Revoked'],
      isGreen: ['FPassed', 'FApproved', 'SendAfterCorrect'],
      isWarning: ['Draft'],
      isInfo: [],
      isPurple: ['ReturnedForRevision', 'MReturnedForRevision', 'CorrectAfterApprove'],
      isTeal: ['Reviewing', 'MApproved'],
      isIndigo: ['Resubmitted', 'MPassed'],
      isPrimary: ['Submitted', 'FReturnedForRevision'],
      isSecondary: ['Closed'],
    }
  }
  if (props.statusComponent === 'ExpenseChange') {
    return {
      isRed: ['Rejected', 'Revoke', 'Revoked'],
      isGreen: ['MApproved', 'FApproved', 'FPassed', 'SendAfterCorrect'],
      isWarning: ['Draft'],
      isInfo: [],
      isPurple: ['ReturnedForRevision', 'MReturnedForRevision', 'FReturnedForRevision', 'CorrectAfterApprove'],
      isTeal: ['Reviewing'],
      isIndigo: [],
      isPrimary: ['Submitted', 'MPassed', 'Resubmitted'],
    }
  }
  return {
    isRed: ['Rejected', 'Revoke', 'Revoked'],
    isGreen: ['Approved', 'Submitted'],
    isWarning: ['Draft'],
  }
})

// 取得人員資料API
const fetchUser = async (userNo: string ) => {
  try {
    const resp = await $api('/tca/userInfo/loadUser', {
      method: 'GET',
      query: {
        compNo: compId.value,
        userNo: props.userInfo,
      },
    });
    return resp;
  } catch (error) {
    console.error("Error fetching user:", error);
    return null;
  }
}

watch(() => props.userInfo, async () => {
  if (props.userInfo) {
    const userData = await fetchUser(props.userInfo);
    if (userData) {
      Object.assign(user, userData);
    }
  }
});

onMounted(async () => {
  if (props && props.userInfo) {
    const userData = await fetchUser(props.userInfo);
    if (userData) {
      Object.assign(user, userData);
    }
  }
});
</script>
<template>
  <v-col v-if="props.isShow[0]" cols="6">
    <v-list-item>
        <v-list-item-title>申請人</v-list-item-title>
        <v-list-item-subtitle>{{ user.cname?user.cname:userData.name }}</v-list-item-subtitle>
        <v-list-item-subtitle>{{ user.userNo?user.userNo:userData.userno }}</v-list-item-subtitle>
    </v-list-item>
  </v-col>
  <v-col v-if="props.isShow[1]" cols="6">
    <v-list-item>
        <v-list-item-title>單位</v-list-item-title>
        <v-list-item-subtitle>{{ user.depNo?toText(user.depNo):userData.depNo }} </v-list-item-subtitle>
        <v-list-item-subtitle>{{ user.depNo?toCode(user.depNo):userData.depNo }} </v-list-item-subtitle>
    </v-list-item>
  </v-col>
  <v-col v-if="props.isShow[2]"cols="6">
    <v-list-item>
        <v-list-item-title>申請單號</v-list-item-title>
        <v-list-item-subtitle>{{props.applicationNumber}}</v-list-item-subtitle>
    </v-list-item>
  </v-col>
  <v-col v-if="props.isShow[4]" cols="6">
    <v-list-item>
        <v-list-item-title>公文發文日期</v-list-item-title>
        <v-list-item-subtitle>{{props.issueDate}} </v-list-item-subtitle>
    </v-list-item>
  </v-col>
  <v-col v-if="props.isShow[5]" cols="6">
    <v-list-item>
        <v-list-item-title>公文號</v-list-item-title>
        <v-list-item-subtitle>{{props.documentNumber}} </v-list-item-subtitle>
    </v-list-item>
  </v-col>
  <slot name="extra"></slot>
  <v-col v-if="props.isShow[3] && props.applicationNumber" cols="12" style="overflow: visible !important;">
    <v-list-item style="overflow: visible !important;">
      <div class="d-flex align-center" style="overflow: visible !important;">
        <v-list-item-title class="me-8" style="flex: 0 0 auto; width: auto;">狀態</v-list-item-title>
        <div style="overflow: visible !important;">
          <Status
            :status="displayStatus"
            v-bind="statusColors"
            :shared-table-id="props.statusComponent"
            btn-class="x-large"
            font-class="18px"
          />
        </div>
      </div>
    </v-list-item>
  </v-col>
</template>
